/*global CONTENT_ROOT */
'use strict';

const cookies = require('./cookies');
const ageGateConfig = require('./ageGateConfig');

module.exports = function setBirthday (date) {
  let re = CONTENT_ROOT.match(/^http[s]?:\/\/[^/]*(.*)$/);
  let path = re ? re[1] : '/';
  let wildcardDomain = window.location.hostname.split('.').slice(-2).join('.');

  cookies.setItem(
    ageGateConfig.cookieName,
    date.getTime(),
    Infinity,
    path,
    wildcardDomain,
  );
};



// WEBPACK FOOTER //
// ./lib/rlink-agegate/setBirthday.js